module.exports = __webpack_public_path__ + "img/microplastics-7-mobile.871b1737.png";